import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchSubscriptionHistory, fetchGiftHistory } from "./service";
import Translate, { useTranslateText } from "../../../Components/Multilanguage/Translate";
import { getUpdatePaymentLink } from "../../../network/service";
import { ReactComponent as CopyIcon } from "../../../assets/Icons/copy.svg";
import { ReactComponent as TickIcon } from "../../../assets/Icons/tick.svg";

const BillingDetails = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [subscriptionHistory, setSubscriptionHistory] = useState({});
  const [giftHistory, setGiftHistory] = useState({});
  const [expiryDate, setExpiryDate] = useState("");
  const [activeTab, setActiveTab] = useState("subscription");
  const [copiedIndex, setCopiedIndex] = useState(null);
  const translateText = useTranslateText();

  const navigate = useNavigate();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    window.scroll(0, 0)
    getSubscriptionHistory();
    getGiftHistory();
  }, []);

  const handleCopy = (code, idx) => {
    if (code) {
      const url = `${window.location.origin}/gift/claim?gc=${code}`;
      navigator.clipboard.writeText(url);
      setCopiedIndex(idx);
      setTimeout(() => setCopiedIndex(null), 1600);
    }
  };

  const getSubscriptionHistory = async () => {
    try {
      const response = await fetchSubscriptionHistory(appInfo);
      if (response?.status === 200) {
        setSubscriptionHistory(response?.data);
        const date = new Date(response?.data?.last_purchase?.valid_to);
        const nextday = new Date(response?.data?.last_purchase?.valid_to);
        nextday.setDate(date.getDate() + 1);
        setExpiryDate(nextday.toDateString());
      }
    } catch (err) { }
  };

  const getGiftHistory = async () => {
    try {
      const response = await fetchGiftHistory(appInfo);
      if (response?.status === 200) {
        setGiftHistory(response?.data);
      }
    } catch (err) { }
  };
  const updatePaymentDetails = async () => {
    const response = await getUpdatePaymentLink(appInfo);
    if (response.status === 200) {
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    }
  };
  return (
    <div className="billingAndSubscription">
      <div className="wrapper">
        <div className="billingDetails">
          <h1 className="heading"><Translate textKey={'billing_details_title'} /></h1>
          <h6 className="subHeading"><Translate textKey={'your_membership'} /></h6>
          {subscriptionHistory?.last_purchase?.mode_of_payment !== 'Giftcard' && <div className="billingDetailsContainer">
            <div>
              <span className="head"><Translate textKey={'your_plan'} /></span>
              <span className="value bold">
                {subscriptionHistory?.last_purchase?.plan}
              </span>

              <span className="head"><Translate textKey={'your_next_bill'} /></span>
              <span className="value">{expiryDate}</span>
            </div>
            <div>
              {subscriptionHistory?.last_purchase?.mode_of_payment !== "Vizio" && subscriptionHistory?.last_purchase?.mode_of_payment !== "vizio" && (
                <div className="billingButtonContainer" onClick={() => { updatePaymentDetails(); }}>
                  <div className="background" />
                  <button>
                    <Translate textKey={'update_payment_method'} />
                  </button>
                </div>
              )}
            </div>
          </div>}
        </div>

        <div className="detailsSection">
          {giftHistory?.data && giftHistory.data.length > 0 ? (
            <>
              <div className="tabContainer">
                <div
                  className={`tab ${activeTab === "subscription" ? "active" : ""}`}
                  onClick={() => setActiveTab("subscription")}
                >
                  <Translate textKey={'subscription_details_title'} />
                </div>
                <div
                  className={`tab ${activeTab === "gift" ? "active" : ""}`}
                  onClick={() => setActiveTab("gift")}
                >
                  <Translate textKey={'gift_details'} />
                </div>
              </div>

              {activeTab === "subscription" && (
                <ul className="subscriptionContainer">
                  <li className="head">
                    <div className="left">
                      <div className="date"><Translate textKey={'date'} /></div>
                      <div className="transactionType"><Translate textKey={'transaction_type'} /></div>
                      <div className="servicePeriod"><Translate textKey={'service_period'} /></div>
                      <div className="paymentMethod"><Translate textKey={'payment_method'} /></div>
                      <div className="subscriptionName"><Translate textKey={'subscription_name'} /></div>
                    </div>
                    <div className="right">
                      <div className="total"><Translate textKey={'total'} /></div>
                    </div>
                  </li>
                  {subscriptionHistory?.purchase_history?.map((item, index) => (
                    <li key={index} className="body">
                      <div className="left">
                        <div className="date">{item?.date}</div>
                        <div className="transactionType">
                          {item?.transaction_type}
                        </div>
                        <div className="servicePeriod">{item?.service_period}</div>
                        <div className="paymentMethod">{item?.mode_of_payment}</div>
                        <div className="subscriptionName">
                          {item?.subscription_name}
                        </div>
                      </div>
                      <div className="right">
                        <div className="total">{item?.total}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {activeTab === "gift" && (
                <ul className="subscriptionContainer">
                  <li className="head">
                    <div className="left">
                      <div className="date"><Translate textKey={'gift'} /></div>
                      <div className="transactionType"><Translate textKey={'status'} /></div>
                      <div className="servicePeriod"><Translate textKey={'purchased_by'} /></div>
                      <div className="paymentMethod"><Translate textKey={'recipient'} /></div>
                      {/* <div className="subscriptionName"><Translate textKey={'redemption_date'}/></div>
                      <div className="subscriptionName"><Translate textKey={'purchase_date'}/></div> */}
                    </div>
                    <div className="right">
                      <div className="total"><Translate textKey={'code'} /></div>
                    </div>
                  </li>
                  {giftHistory?.data?.map((item, index) => (
                    <li key={index} className="body">
                      <div className="left">
                        <div className="date">
                          <div>{item?.period} x {item?.plan_name}</div>
                        </div>
                        <div className="transactionType">
                          {item?.status}
                        </div>
                        <div className="servicePeriod">{item?.buyer_info}</div>
                        <div className="paymentMethod">{item?.recipient_info || "-"}</div>
                        {/* <div className="subscriptionName">{item?.redeemed_date ? new Date(item.redeemed_date).toLocaleDateString() : "-"}</div>
                        <div className="subscriptionName">{item?.purchase_date ? new Date(item.purchase_date).toLocaleDateString() : "-"}</div> */}
                      </div>
                      <div className="right">
                        <div className="total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                          <span>{item?.giftcode}</span>
                          {item?.status !== 'REDEEMED' && item?.giftcode && (
                            <button
                              className={`copyGiftCodeBtn${copiedIndex === index ? ' copied' : ''}`}
                              onClick={() => handleCopy(item.giftcode, index)}
                              title={copiedIndex === index ? translateText('copied') : 'Copy claim URL'}
                              aria-label="Copy claim URL"
                              type="button"
                              style={{ marginLeft: 8 }}
                            >
                              <span className="icon-wrapper" style={{ position: 'relative', width: 20, height: 20, display: 'inline-block' }}>
                                <CopyIcon width={18} height={18} className={copiedIndex === index ? 'icon-hide' : 'icon-show'} style={{ position: 'absolute', left: 0, top: 0 }} />
                                <TickIcon width={18} height={18} className={copiedIndex === index ? 'icon-show' : 'icon-hide'} style={{ position: 'absolute', left: 0, top: 0 }} />
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </>
          ) : (
            <>
              <h1 className="heading"><Translate textKey={'subscription_details_title'} /></h1>
              <ul className="subscriptionContainer">
                <li className="head">
                  <div className="left">
                    <div className="date"><Translate textKey={'date'} /></div>
                    <div className="transactionType"><Translate textKey={'transaction_type'} /></div>
                    <div className="servicePeriod"><Translate textKey={'service_period'} /></div>
                    <div className="paymentMethod"><Translate textKey={'payment_method'} /></div>
                    <div className="subscriptionName"><Translate textKey={'subscription_name'} /></div>
                  </div>
                  <div className="right">
                    <div className="total"><Translate textKey={'total'} /></div>
                  </div>
                </li>
                {subscriptionHistory?.purchase_history?.map((item, index) => (
                  <li key={index} className="body">
                    <div className="left">
                      <div className="date">{item?.date}</div>
                      <div className="transactionType">
                        {item?.transaction_type}
                      </div>
                      <div className="servicePeriod">{item?.service_period}</div>
                      <div className="paymentMethod">{item?.mode_of_payment}</div>
                      <div className="subscriptionName">
                        {item?.subscription_name}
                      </div>
                    </div>
                    <div className="right">
                      <div className="total">{item?.total}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>

        <div className="bottom">
          <p><Translate textKey={'note_billing_msg'} /></p>
          {(subscriptionHistory?.last_purchase?.mode_of_payment === "Vizio" || subscriptionHistory?.last_purchase?.mode_of_payment === "vizio") && (
            <div className="vizio">
              <Translate textKey={'vizio_subscription_message'} /><span onClick={() => window.open('https://www.vizio.com/en/vizio-account', '_blank')}>https://www.vizio.com/en/vizio-account</span>.
            </div>
          )}
          <div className="buttonContainer" onClick={() => navigate("/account")}>
            <div className="background" />
            <button ><Translate textKey={'back'} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDetails;
